import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { Steps } from "primereact/steps";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { RestAPI } from "@aws-amplify/api-rest";
import { toast } from "react-toastify";

import withName from "../../hoc/withName";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import ButtonPrime from "../PrimeComponents/ButtonPrime";

const BillingParams = ({showMiniWizzard, setIsLoading, setNewDatosFact,setOnEditFact,  formikRefDatosFact, setShowMiniWizzard,farmInfo, originalValues,setOnEdit,  setBillingInfoFarm, countries,formikRef, hubs,clients, pricesLists,setLoadingClients, setOriginalValues, newDatosFactList, setNewDatosFactList }) => {

    const { t, i18n } = useTranslation();
    const [activeStep, setActiveStep] = useState(0);
    const [activeBillingData, setActiveBillingData] = useState("keep");
    const [activeBillingConfig, setActiveBillingConfig] = useState("keep");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [errors, setErrors] = useState({});
    const [selectedBillingData, setSelectedBillingData] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedConfig, setSelectedConfig] = useState({hub:null, lista:null});
    const reset = () => {
        setActiveStep(0);
        setActiveBillingData("keep");
        setActiveBillingConfig("keep");
        setGlobalFilterValue("");
        setSelectedBillingData(null);
        setSelectedConfig({hub:null, lista:null});
        setSelectedClient(null);
        setOnEditFact(false);
    };
    useEffect(() => {
        if(countries){
            countries.forEach(c => {
                c.nombre = t(`countries.${c.tipo_pais_id}`);
            });
        }
    },[countries,t]);
    const newDatosFact = {
        "datos_fact_id":0,
        "vat_id":"",
        "nombre":"",
        "direccion":"",
        "ciudad":""};
    const items = [
        {
            label: t("billing.nCliente")
        },
        {
            label: t("billing.config")
        },
        {
            label: t("billing.billingData")
        },
        {
            label: t("farms.summary")
        }
    ];
    const accountTemplate = (rowData) => {
        const accounts = rowData?.cuentas?.map((e, index, array) => (
            <tr className={`innerTrTableRowspan ${index < array.length - 1 ? "oddRowInner" : ""} w-100`} key={index}>
                {e}
            </tr>
        ));
        return accounts;
    };
    const farmsTemplate = (rowData) => {
        const accounts = rowData?.campos?.map((e, index, array) => (
            <tr className={`innerTrTableRowspan ${index < array.length - 1 ? "oddRowInner" : ""} w-100`} key={index}>
                {e}
            </tr>
        ));
        return accounts;
    };
    useEffect(() => {
        if(activeBillingData === "new"){
            setSelectedBillingData(newDatosFact);
        }
        else if(activeBillingData === "keep"){
            if(farmInfo.datos_fact){
                setSelectedBillingData(farmInfo.datos_fact);
            }
        }
        else if(activeBillingData === "existing"){
            setSelectedBillingData(selectedClient?.datos_fact?.[0]?.list?.find((d) => d.datos_fact_id === selectedClient.datos_fact_id)??newDatosFact);
        }
    },[activeBillingData,selectedClient,farmInfo]);
    useEffect(() => {
        if(activeBillingConfig === "keep" && selectedClient==null){
            setSelectedConfig({hub:farmInfo?.hub, lista:farmInfo?.lista});
        }
        if(activeBillingConfig === "keep" && selectedClient!==null){
            setSelectedConfig(
                {
                    hub:hubs?.find((d) => d.hub_id === selectedClient?.hub_id),
                    lista:pricesLists?.find((d) => d.lista_precio_id === selectedClient?.lista_precio_id)
                });
        }
        else if (activeBillingConfig === "change"){
            setSelectedConfig({hub:null, lista:null});
        }
    },[activeBillingConfig,selectedClient,farmInfo, pricesLists, hubs]);
    useEffect(() => {
        if(!showMiniWizzard){
            reset();
            setShowMiniWizzard(false);
        }else{
            setSelectedClient(clients?.find((e) => parseInt(e.n_cliente_id) === farmInfo?.n_cliente_id));
            setSelectedBillingData(farmInfo?.datos_fact);
            setSelectedConfig({hub:farmInfo?.hub, lista:farmInfo?.lista});
        }
    },[showMiniWizzard,clients]);

    const checkError = (data) => {
        const invalid = {};
        if(!data?.nombre){
            invalid.datos_fact_nombre = "Required";
        }
        if(!data?.direccion){
            invalid.datos_fact_direccion = "Required";
        }
        if(!data?.ciudad){
            invalid.datos_fact_ciudad = "Required";
        }
        if(!data?.tipo_pais_id){
            invalid.datos_fact_tipo_pais_id = "Required";
        }
        const requiredVat = countries?.find(c => c?.tipo_pais_id === data?.tipo_pais_id)?.required_vat;
        if(requiredVat && !data?.vat_id){
            invalid.datos_fact_vat_id = "Required";
        }
        setErrors(invalid);
        return invalid;
    };
    useEffect(() => {
        if(selectedBillingData){
            checkError(selectedBillingData);
        }

    },[selectedBillingData]);
    return (
        <Dialog
            header={t("billing.updateNewClient")} visible={showMiniWizzard} style={{ width: "85vw" }}
            onHide={() => {setShowMiniWizzard(false);}} footer={
                <div className="col-xl-12 col-lg-12 col-sm-12 text-sm-left mtem-05 dialogBtnsBilling">
                    <ButtonPrime disabled={activeStep===0?true:false} label={t("billing.back")} onClick={() => {
                        if(activeStep===2 && selectedClient!=null){
                            setActiveStep(0);
                        }
                        else {
                            setActiveStep(activeStep-1);
                        }
                    }} raised
                    />
                    <ButtonPrime label={activeStep===3?t("forms.save"):t("external.next")} onClick={() => {
                        if(activeStep===3){
                            const isValid= (Object.keys(checkError(selectedBillingData))?.length === 0);
                            if(isValid){
                                setIsLoading(true);
                                const formData={
                                    "campo_id":farmInfo.campo_id,
                                    "n_cliente_id":selectedClient?.n_cliente_id??0,
                                    "hub_id":selectedConfig?.hub?.hub_id,
                                    "lista_precio_id":selectedConfig?.lista?.lista_precio_id,
                                    "datos_fact":selectedBillingData
                                };
                                RestAPI.post("apiAdminDropControl", "/billing/clients", {body: formData}).then(async (response) => {
                                    setLoadingClients(false);
                                    toast.success(t("billing.billingparamsSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                    if(formData.n_cliente_id===0){
                                        setNewDatosFact(response?.newDatosFact?.[0]);
                                        const newDatosFactList = [response?.newDatosFact?.[0]];
                                        setNewDatosFactList(newDatosFactList);
                                        formikRef?.current && formikRef?.current?.setFieldValue("datos_fact",response?.newDatosFact?.[0]);
                                        formikRef?.current && formikRef?.current?.setFieldValue("n_cliente_id",response?.updatedClient?.n_cliente_id);
                                        formikRef?.current && formikRef?.current?.setFieldValue("hub",selectedConfig?.hub?.nombre);
                                        formikRef?.current && formikRef?.current?.setFieldValue("list",selectedConfig?.lista?.nombre);
                                        setBillingInfoFarm({
                                            ...farmInfo,
                                            hub:selectedConfig.hub,
                                            datos_fact:response?.newDatosFact?.[0],
                                            datos_fact_list:newDatosFactList,
                                            n_cliente_id:response?.updatedClient?.n_cliente_id
                                        });
                                        setOriginalValues({
                                            ...originalValues,datos_fact:response?.newDatosFact?.[0],
                                            n_cliente_id:response?.updatedClient?.n_cliente_id,
                                            hub:selectedConfig?.hub?.nombre,
                                            list:selectedConfig?.lista?.nombre,});

                                    }else{
                                        let datosFactNewOrUp = null;
                                        let newDatosFactList = selectedClient?.datos_fact?.[0].list;
                                        if(response?.newDatosFact){
                                            datosFactNewOrUp = response?.newDatosFact?.[0];
                                            setNewDatosFact(datosFactNewOrUp);
                                            newDatosFactList = newDatosFactList.concat(datosFactNewOrUp);
                                        }else{
                                            datosFactNewOrUp = response?.updatedDatosFact?.[0];
                                        }
                                        setNewDatosFactList(newDatosFactList);
                                        formikRef?.current && formikRef?.current?.setFieldValue("datos_fact",datosFactNewOrUp);
                                        formikRefDatosFact?.current && formikRefDatosFact?.current?.setFieldValue("datos_fact",datosFactNewOrUp);
                                        formikRef?.current && formikRef?.current?.setFieldValue("n_cliente_id",response?.updatedClient?.n_cliente_id);
                                        formikRef?.current && formikRef?.current?.setFieldValue("hub",selectedConfig?.hub?.nombre);
                                        formikRef?.current && formikRef?.current?.setFieldValue("list",selectedConfig?.lista?.nombre);

                                        setBillingInfoFarm({
                                            ...farmInfo,
                                            hub:selectedConfig.hub,
                                            datos_fact:datosFactNewOrUp,
                                            datos_fact_list:newDatosFactList,
                                            n_cliente_id:response?.updatedClient?.n_cliente_id
                                        });
                                        setOriginalValues({
                                            ...originalValues,datos_fact:datosFactNewOrUp,
                                            n_cliente_id:response?.updatedClient?.n_cliente_id,
                                            hub:selectedConfig?.hub?.nombre,
                                            list:selectedConfig?.lista?.nombre,});

                                    }
                                    setIsLoading(false);
                                    setOnEdit(false);
                                    setOnEditFact(false);
                                    setShowMiniWizzard(false);
                                })
                                    .catch((error) => {
                                        if(error?.response?.data === "MISSING_FACT_DATA"){
                                            toast.error(t("billing.errorMissingData"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                        }
                                        else if(error?.response?.data === "MISSING_VAT"){
                                            toast.error(t("billing.errorMissingVat"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                        }
                                        else{
                                            toast.error(t("billing.billingparamsError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                        }
                                        setLoadingClients(false);
                                        console.log(error);
                                    });

                            }else{
                                setActiveStep(activeStep-1);
                            }
                        }else{
                            if(activeStep===0 && selectedClient !== null){
                                setActiveStep(2);
                            }else{
                                setActiveStep(activeStep+1);
                            }
                        }
                    }} raised
                    />
                </div>
            }
        >
            <Steps model={items} onSelect={(e) => setActiveStep(e.index)} activeIndex={activeStep} />
            {
                activeStep===0?
                    <div className='p-2'>
                        <DataTablePrime
                            t={t}
                            header="search"
                            isSelectable
                            rowGroupMode="rowspan" scrollable scrollHeight="30vh"
                            paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                            value={clients} size="small" tableStyle={{ minWidth: "80vw" }}
                            selectionMode="single" selection={selectedClient} notMultiSelect
                            onSelectionChange={
                                (e) => {
                                    setSelectedClient(e.value);
                                }
                            } dataKey="n_cliente_id"
                            filters={{
                                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                n_cliente_id: { value: null, matchMode: FilterMatchMode.EQUALS },
                                pricelist_name: { value: null, matchMode: FilterMatchMode.EQUALS },
                                hub_name: { value: null, matchMode: FilterMatchMode.EQUALS },
                                cuentas: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                campos: { value: null, matchMode: FilterMatchMode.CONTAINS }
                            }}
                            globalFilterFields={["n_cliente_id", "pricelist_name", "hub_name", "cuentas", "campos"]}
                            fields={[
                                {field:"n_cliente_id",header:t("billing.nCliente"), bodyStyle:{textAlign:"center"}},
                                {field:"pricelist_name",header:t("billing.priceListPage.title"), bodyStyle:{textAlign:"center"}},
                                {field:"hub_name",header:t("billing.hub"), bodyStyle:{textAlign:"center"}},
                                {field:"cuentas",header:t("billing.clientParamsPage.table.account"), body:accountTemplate, bodyStyle:{textAlign:"center"}},
                                {field:"campos",header:t("billing.clientParamsPage.table.farm"), body:farmsTemplate, bodyStyle:{textAlign:"center"}},
                            ]}
                        />
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-sm-left mtem-05 dialogBtnsBilling">
                            <ButtonPrime label={t("billing.newClientId")} onClick={() => {
                                setSelectedClient(null);
                                if(farmInfo.datos_fact){
                                    setSelectedBillingData(farmInfo.datos_fact);
                                    setActiveBillingData("keep");
                                }else{
                                    setActiveBillingData("new");
                                }
                                setActiveStep(1);
                            }} raised
                            />
                        </div>
                    </div>
                    :null
            }
            {
                activeStep===1?
                    <div className="flex flex-column flex-wrap gap-4 p-2">
                        <div className="flex align-items-center mb-2">
                            <RadioButton disabled={!farmInfo.hub || !farmInfo.lista} inputId="activeBillingConfig1" name="activeBilling" value="keep" onChange={(e) => {setActiveBillingConfig(e.value);}} checked={activeBillingConfig === "keep"} />
                            <label htmlFor="activeBillingConfig1" className="ml-2 mb-0">{t("billing.clientBillingConfig.keep")}</label>
                        </div>
                        <div className="flex align-items-center mb-2">
                            <RadioButton inputId="activeBillingConfig2" name="activeBilling" value="change" onChange={(e) => {setActiveBillingConfig(e.value);}} checked={activeBillingConfig === "change"} />
                            <label htmlFor="activeBillingConfig2" className="ml-2 mb-0">{t("billing.clientBillingConfig.change")}</label>
                        </div>
                        <div className='p-2'>
                            <div className="row linea-formulario">
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("billing.hub")}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    {
                                        activeBillingConfig==="change"?
                                            <Dropdown
                                                value={selectedConfig?.hub?.hub_id}
                                                onChange={(e) => {setSelectedConfig({...selectedConfig,hub:hubs?.find((d) => d.hub_id === e.target.value)});}}
                                                options={hubs} optionLabel="nombre" optionValue="hub_id"
                                                className="flex lgInputCstmDialog w-100 p-0-ddpr" placeholder={t("forms.pHolderSelect")}
                                                inputId="hub_id" name="hub_id"
                                            />
                                            : <label >{hubs?.find((d) => d.hub_id ===  selectedConfig?.hub?.hub_id)?.nombre}</label>
                                    }
                                </div>
                            </div>
                            <div className="row linea-formulario">
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("billing.sideBar.priceList")}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    {
                                        activeBillingConfig==="change"?
                                            <Dropdown
                                                value={selectedConfig?.lista?.lista_precio_id}
                                                onChange={(e) => {setSelectedConfig({...selectedConfig,lista:pricesLists?.find((d) => d.lista_precio_id === e.target.value)});}}
                                                options={pricesLists} optionLabel="nombre" optionValue="lista_precio_id"
                                                className="flex lgInputCstmDialog w-100 p-0-ddpr" placeholder={t("forms.pHolderSelect")}
                                                inputId="lista_precio_id" name="lista_precio_id"
                                            />
                                            : <label >{pricesLists?.find((d) => d.lista_precio_id ===  selectedConfig?.lista?.lista_precio_id)?.nombre}</label>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    :null
            }
            {
                activeStep===2?
                    <div className="flex flex-column flex-wrap gap-4 p-2">
                        <div className="flex align-items-center mb-2">
                            <RadioButton disabled={!farmInfo?.datos_fact} inputId="activeBilling1" name="activeBilling" value="keep" onChange={(e) => {setActiveBillingData(e.value);}} checked={activeBillingData === "keep"} />
                            <label htmlFor="activeBilling1" className="ml-2 mb-0">{t("billing.clientBillingFact.keep")}</label>
                        </div>
                        <div className="flex align-items-center mb-2">
                            <RadioButton inputId="activeBilling2" name="activeBilling" value="new" onChange={(e) => {setActiveBillingData(e.value);}} checked={activeBillingData === "new"} />
                            <label htmlFor="activeBilling2" className="ml-2 mb-0">{t("billing.clientBillingFact.new")}</label>
                        </div>
                        <div className="flex align-items-center mb-2">
                            <RadioButton disabled={selectedClient==null} inputId="activeBilling3" name="activeBilling" value="existing" onChange={(e) => {setActiveBillingData(e.value);}} checked={activeBillingData === "existing"} />
                            <label htmlFor="activeBilling3" className="ml-2 mb-0">{t("billing.clientBillingFact.existing")}</label>
                        </div>
                        <div className='p-2'>
                            {
                                activeBillingData==="existing"?
                                    <div className="row linea-formulario">
                                        <div className="col-xl-6 col-lg-12 col-sm-12">
                                            <label className="boldie">{t("billing.billingData")}</label>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-12">
                                            <Dropdown
                                                value={selectedBillingData?.datos_fact_id}
                                                onChange={(e) => {setSelectedBillingData(selectedClient.datos_fact[0].list.find((d) => d.datos_fact_id === e.target.value));}}
                                                options={selectedClient?.datos_fact?.[0]?.list??[]} optionLabel="nombre" optionValue="datos_fact_id"
                                                className="flex lgInputCstmDialog w-100 p-0-ddpr" placeholder={t("billing.policyPage.sellectData")}
                                                inputId="datos_fact_id" name="datos_fact_id"
                                            />
                                        </div>
                                    </div>
                                    : <label >{clients?.find(m => m.datos_fact_id === selectedBillingData?.datos_fact_id)?.nombre}</label>
                            }
                            {
                                activeBillingData!=="existing"?
                                    <div className="row linea-formulario">
                                        <div className="col-xl-6 col-lg-12 col-sm-12">
                                            <label className="boldie">{t("general.name")}</label>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-12">
                                            {
                                                activeBillingData==="new"?
                                                    <>
                                                        <InputText className="flex lgInputCstmDialog w-100 " value={selectedBillingData?.nombre} onChange={(e) => setSelectedBillingData({...selectedBillingData,nombre:e.target.value})} />
                                                        {errors?.datos_fact_nombre?<small className="p-error text-danger">{t("validation.required")}</small>:null}
                                                    </>
                                                    :<label className='boldie'>{selectedBillingData?.nombre}</label>
                                            }
                                        </div>
                                    </div>
                                    :null
                            }
                            <div className="row linea-formulario">
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("billing.policyPage.vat")}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    {
                                        activeBillingData!=="new"?
                                            <label >{selectedBillingData?.vat_id}</label>
                                            :
                                            <>
                                                <InputText className="flex lgInputCstmDialog w-100 " value={selectedBillingData?.vat_id} onChange={(e) => setSelectedBillingData({...selectedBillingData,vat_id:e.target.value})} />
                                                {errors?.datos_fact_vat_id?<small className="p-error text-danger">{t("validation.required")}</small>:null}
                                            </>
                                    }
                                </div>
                            </div>
                            <div className="row linea-formulario">
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("personal.address")}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    {
                                        activeBillingData!=="new"?
                                            <label >{selectedBillingData?.direccion}</label>
                                            :
                                            <>
                                                <InputText className="flex lgInputCstmDialog w-100 " value={selectedBillingData?.direccion} onChange={(e) => setSelectedBillingData({...selectedBillingData,direccion:e.target.value})} />
                                                {errors?.datos_fact_direccion?<small className="p-error text-danger">{t("validation.required")}</small>:null}
                                            </>
                                    }
                                </div>
                            </div>
                            <div className="row linea-formulario">
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("personal.city")}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    {
                                        activeBillingData!=="new"?
                                            <label >{selectedBillingData?.ciudad}</label>
                                            :
                                            <>
                                                <InputText className="flex lgInputCstmDialog w-100 " value={selectedBillingData?.ciudad} onChange={(e) => setSelectedBillingData({...selectedBillingData,ciudad:e.target.value})} />
                                                {errors?.datos_fact_ciudad?<small className="p-error text-danger">{t("validation.required")}</small>:null}
                                            </>
                                    }
                                </div>
                            </div>
                            <div className="row linea-formulario">
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("billing.policyPage.country")}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    {
                                        activeBillingData!=="new"?
                                            <label >{t(`countries.${selectedBillingData?.tipo_pais_id}`)}</label>
                                            :
                                            <>
                                                <Dropdown
                                                    value={selectedBillingData?.tipo_pais_id}
                                                    onChange={(e) => setSelectedBillingData({...selectedBillingData,tipo_pais_id:e.target.value})}
                                                    options={countries} optionLabel="nombre" optionValue="tipo_pais_id"
                                                    className="flex lgInputCstmDialog w-100 p-0-ddpr" placeholder={t("forms.pHolderSelect")}
                                                    inputId="tipo_pais_id" name="tipo_pais_id"
                                                />
                                                {errors?.datos_fact_tipo_pais_id?<small className="p-error text-danger">{t("validation.required")}</small>:null}
                                            </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    :null
            }
            {
                activeStep===3?
                    <div className='p-2'>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("billing.nCliente")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{
                                    selectedClient?.n_cliente_id ?? t("billing.newClientId")
                                }</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("billing.billingData")}</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("general.name")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{selectedBillingData?.nombre}</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("billing.policyPage.vat")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{selectedBillingData?.vat_id}</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("billing.policyPage.country")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{t(`countries.${selectedBillingData?.tipo_pais_id}`)}</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("personal.city")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{selectedBillingData?.ciudad}</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("personal.address")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{selectedBillingData?.direccion}</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("billing.priceListPage.title")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{selectedConfig?.lista?.nombre}</label>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className="boldie">{t("billing.hub")}</label>
                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-12">
                                <label className='boldie'>{selectedConfig?.hub?.nombre}</label>
                            </div>
                        </div>
                    </div>
                    :null
            }
        </Dialog>
    );
};

export default withName(BillingParams, "BillingParams");
